import { FunctionComponent } from 'react';
import { ServiceOrder } from '../../serviceOrders/serviceOrder.types';
import { ServiceOption } from '../../serviceOptions/serviceOption.types';
import { useAppDispatch } from '../../../../../configuration/setup/hooks';
import Button from '@rio-cloud/rio-uikit/Button';
import { serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { FormattedMessage } from 'react-intl';

export const hasServiceOptionId = (
    serviceOrderOrOption: ServiceOrder | ServiceOption,
): serviceOrderOrOption is ServiceOrder & { externalOptionId: string } =>
    'externalOptionId' in serviceOrderOrOption && !!serviceOrderOrOption.externalOptionId;

export const isServiceOption = (
    serviceOrderOrOption: ServiceOrder | ServiceOption,
): serviceOrderOrOption is ServiceOption => 'services' in serviceOrderOrOption;

type ServiceOrderOrOptionLinkButtonProps = {
    serviceOrderOrOption: ServiceOrder | ServiceOption;
};

export const ServiceOrderOrOptionLinkButton: FunctionComponent<ServiceOrderOrOptionLinkButtonProps> = ({
    serviceOrderOrOption,
}) => {
    const dispatch = useAppDispatch();

    if (hasServiceOptionId(serviceOrderOrOption)) {
        return (
            <Button
                bsStyle={Button.PRIMARY}
                variant={Button.VARIANT_LINK}
                bsSize={Button.XS}
                iconName="rioglyph-group"
                onClick={() =>
                    dispatch(serviceOrdersSlice.actions.jumpToServiceOption(serviceOrderOrOption.externalOptionId))
                }
            >
                <FormattedMessage id="outboundOrderBook.serviceOrder.sidebar.linkToServiceOption" />
            </Button>
        );
    } else if (isServiceOption(serviceOrderOrOption)) {
        return (
            <Button
                bsStyle={Button.PRIMARY}
                variant={Button.VARIANT_LINK}
                bsSize={Button.XS}
                iconName="rioglyph-document"
                onClick={() =>
                    dispatch(serviceOrdersSlice.actions.jumpToServiceOrder(serviceOrderOrOption.externalOrderId))
                }
            >
                <FormattedMessage id="outboundOrderBook.serviceOrder.sidebar.linkToRelatedServiceOrders" />
            </Button>
        );
    } else {
        return null;
    }
};
